import { ActivityProperties } from '../activity-base.model';
import {
  ResidentialProgramType,
  isResidentialProgramType,
} from './program-type.model';

type ActivityResidentialNumericProperties = ActivityProperties<{
  living_area_per_apartment: number;
  balcony_area_per_apartment: number;
  bathroom_area_per_apartment: number;
}>;

export type ActivityResidentialProperties =
  ActivityResidentialNumericProperties & {
    program_type: ResidentialProgramType;
  };

export const defaultResidentialProperties: ActivityResidentialProperties = {
  program_type: ResidentialProgramType.Multifamily,
  living_area_per_apartment: 60,
  balcony_area_per_apartment: 5,
  bathroom_area_per_apartment: 5,
};

/**
 * Legacy residential activities without {@link ResidentialProgramType} map to multifamily.
 */
export const resolveResidentialProgramType = (
  value: unknown,
): ResidentialProgramType =>
  isResidentialProgramType(value) ? value : ResidentialProgramType.Multifamily;
